import axios from 'axios'

export const instance = axios.create({
  baseURL: 'https://api.dnotes.icu/v3',
  timeout: 100000,
  headers: { accept: 'application/json' },
})

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NETWORK') {
      console.warn('[API] Network error:', error.config?.url)
    }
    return Promise.reject(error)
  }
)

instance.interceptors.request.use((config) => {
  const retrieveToken = (key: string): string | null => {
    if (typeof window === 'undefined') return null
    const token = window.localStorage.getItem(key)
    return token ? JSON.parse(token) : ''
  }

  const accessTokenForDoctor = retrieveToken('accessTokenState')
  const accessTokenForViewer = retrieveToken('accessTokenForViewerState')
  const accessTokenForChart = retrieveToken('accessTokenForChartState')

  const pathname = typeof window === 'undefined' ? null : window.location.pathname

  let accessToken: string | null

  console.log('pathname',pathname)
  // TODO: https://github.com/jangjunha/dnotes-backend-v3/issues/6 완료되는 대로 삭제해야 함
  if (pathname?.includes('/viewer')) {
    accessToken = accessTokenForViewer
  } else if (pathname == '/c/charts' || pathname == '/c') {
    accessToken = accessTokenForChart
  } else {
    accessToken = accessTokenForDoctor
  }

  const isAuthEndpoint = config.url?.includes('/login/access-token')

  if (config.headers && !config.headers['Authorization'] && accessToken && !isAuthEndpoint) {
    config.headers['Authorization'] = `Bearer ${accessToken}`
    return config
  }
  return config
})
